(function () {
  'use strict';

  var QUICKSHOP_TRIGGER_SELECTOR =
    '.product-details-icon, [class*="js-modal-open-quick-modal"], [data-quick-shop-trigger]';

  var raf =
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      return setTimeout(callback, 16);
    };

  function parseJSON(el) {
    if (!el) return [];
    try {
      return JSON.parse(el.value || el.textContent || '[]');
    } catch (err) {
      return [];
    }
  }

  function setImage(img, data) {
    if (!img || !data || !data.src) return;

    img.src = data.src;

    if (data.srcset) {
      img.srcset = data.srcset;
    } else {
      img.removeAttribute('srcset');
    }
  }

  function getImageDataFromSlide(slide) {
    if (!slide) return null;

    var img = slide.querySelector('img');
    if (!img) return null;

    return {
      src: img.getAttribute('src') || img.getAttribute('data-src') || '',
      srcset: img.getAttribute('srcset') || img.getAttribute('data-srcset') || ''
    };
  }

  function animateSlide(element, start, end, duration) {
    if (!element) return;

    var startTime = null;

    function animation(currentTime) {
      if (!startTime) startTime = currentTime;

      var progress = currentTime - startTime;
      var percent = Math.min(progress / duration, 1);
      var value = start + (end - start) * percent;

      element.style.transform = 'translateX(' + value + '%)';

      if (percent < 1) {
        raf(animation);
      }
    }

    raf(animation);
  }

  function getProductRoot(form) {
    return (
      form.closest('.product-single__meta') ||
      form.closest('.product-section') ||
      document
    );
  }

  function getVariantJsonFromRoot(root) {
    var el =
      root.querySelector('.product-variants-json') ||
      root.querySelector('textarea[data-variant-json]') ||
      root.querySelector('textarea[data-current-variant-json]');

    return parseJSON(el);
  }

  function getInventory(productId, variantId) {
    if (
      !productId ||
      !window.inventories ||
      !window.inventories[productId] ||
      !window.inventories[productId][variantId]
    ) {
      return { quantity: 0, policy: 'deny' };
    }

    return window.inventories[productId][variantId];
  }

  function getProductId(form) {
    var input = form.querySelector('input[name="product-id"]');
    return input ? input.value : null;
  }

  function getVariantAvailability(form, variant) {
    if (!form || !variant) {
      return {
        quantity: 0,
        policy: 'deny',
        isAvailable: false,
        isPreorder: false,
        isNotifyOnly: true
      };
    }

    var productId = getProductId(form);
    var inv = getInventory(productId, variant.id);
    var qty = Number(inv.quantity || 0);
    var policy = inv.policy || variant.inventory_policy || 'deny';
    var variantAvailable = !!variant.available;

    var isAvailable = variantAvailable && qty > 0;
    var isPreorder = !isAvailable && policy === 'continue';
    var isNotifyOnly = !isAvailable && !isPreorder;

    return {
      quantity: qty,
      policy: policy,
      isAvailable: isAvailable,
      isPreorder: isPreorder,
      isNotifyOnly: isNotifyOnly
    };
  }

  function getFirstAvailableVariant(form) {
    var root = getProductRoot(form);
    var variants = getVariantJsonFromRoot(root);

    if (!variants.length) return null;

    for (var i = 0; i < variants.length; i++) {
      var availability = getVariantAvailability(form, variants[i]);
      if (availability.isAvailable) {
        return variants[i];
      }
    }

    for (var j = 0; j < variants.length; j++) {
      var preorderAvailability = getVariantAvailability(form, variants[j]);
      if (preorderAvailability.isPreorder) {
        return variants[j];
      }
    }

    return variants[0] || null;
  }

  function shouldIgnoreDisabledState(optionIndex, item, input) {
    var resolvedIndex =
      optionIndex ||
      (input && input.getAttribute('data-index')) ||
      (item && item.getAttribute('data-index')) ||
      '';

    return String(resolvedIndex) === 'option1';
  }

  function setCheckedInputByIndex(root, optionIndex, optionValue) {
    if (!root || !optionIndex || optionValue == null || optionValue === '') return;

    var inputs = root.querySelectorAll(
      '[data-variant-input][data-index="' + optionIndex + '"]'
    );

    if (!inputs.length) return;

    Array.prototype.forEach.call(inputs, function (input) {
      var item = input.closest('.variant-input');
      var isMatch = String(input.value) === String(optionValue);
      var ignoreDisabled = shouldIgnoreDisabledState(optionIndex, item, input);

      var isDisabled =
        !ignoreDisabled &&
        (
          input.disabled ||
          input.classList.contains('is-disabled') ||
          input.getAttribute('data-size-stock') === '0' ||
          (item &&
            (
              item.classList.contains('is-disabled') ||
              item.getAttribute('data-size-stock') === '0'
            ))
        );

      if (isDisabled) {
        input.checked = false;

        if (item) {
          item.classList.remove('is-selected');
          item.classList.remove('is-clicked');
        }

        return;
      }

      input.checked = isMatch;

      if (item) {
        item.classList.toggle('is-selected', isMatch);
        item.classList.toggle('is-clicked', isMatch);
      }
    });
  }

  function applyVariantToUI(form, variant) {
    if (!form || !variant) return;

    var root = getProductRoot(form);
    var variantSelect = form.querySelector('[data-product-select]');

    if (variantSelect) {
      variantSelect.value = String(variant.id);
    }

    setCheckedInputByIndex(root, 'option1', variant.option1);
    setCheckedInputByIndex(root, 'option2', variant.option2);
    setCheckedInputByIndex(root, 'option3', variant.option3);
  }

  function ensureAddButtonText(addBtn, label) {
    if (!addBtn) return;

    var addText = addBtn.querySelector('[data-add-to-cart-text]');

    if (!addText) {
      addText = document.createElement('span');
      addText.setAttribute('data-add-to-cart-text', '');
      addBtn.appendChild(addText);
    }

    addText.textContent = label;
    addText.innerText = label;
    addText.style.display = 'inline';
    addText.style.visibility = 'visible';
    addText.style.opacity = '1';

    addBtn.setAttribute('aria-label', label);
    addBtn.setAttribute('data-button-label', label);
  }

  function getProductDataFromForm(form) {
    if (!form) return null;

    var btn = form.querySelector('[data-add-to-cart][data-product-json]');
    if (!btn) return null;

    try {
      return JSON.parse(btn.getAttribute('data-product-json'));
    } catch (e) {
      return null;
    }
  }

  function openNotifyModal(form, variant) {
    if (!form || !variant) return;

    if (!window._RestockRocket || typeof window._RestockRocket.openModal !== 'function') {
      return;
    }

    var productData = getProductDataFromForm(form);
    if (!productData) return;

    window._RestockRocket.openModal(productData, String(variant.id));
  }

  function setCartCTA(form) {
    var addBtn = form.querySelector('[data-add-to-cart]');
    if (!addBtn) return;

    addBtn.style.display = '';
    addBtn.disabled = false;
    addBtn.classList.remove('out-of-stock');
    addBtn.setAttribute('type', 'submit');
    addBtn.setAttribute('data-cta-mode', 'cart');
    addBtn.onclick = null;

    ensureAddButtonText(addBtn, 'ADD TO CART');
  }

  function updateCTA(form, variant) {
    if (!form || !variant) return;

    var availability = getVariantAvailability(form, variant);

    var addBtn = form.querySelector('[data-add-to-cart]');
    var buyNow = form.querySelector(
      '.shopify-payment-button, [data-shopify="payment-button"], .dynamic-payment-buttons'
    );
    var notifyWrap = form.querySelector('.restock-rocket-button-container');

    form.classList.remove('is-in-stock', 'is-preorder', 'is-notify-only');

    if (availability.isAvailable) {
      form.classList.add('is-in-stock');

      if (addBtn) {
        addBtn.style.display = '';
        addBtn.disabled = false;
        addBtn.setAttribute('type', 'submit');
        addBtn.classList.remove('out-of-stock');
        addBtn.setAttribute('data-cta-mode', 'cart');
        ensureAddButtonText(addBtn, 'ADD TO CART');
      }

      if (notifyWrap) {
        notifyWrap.style.display = 'none';
        notifyWrap.setAttribute('aria-hidden', 'true');
      }

      if (buyNow) {
        buyNow.style.display = '';
      }

      return;
    }

    form.classList.add('is-preorder');

    if (addBtn) {
      addBtn.style.display = '';
      addBtn.disabled = false;
      addBtn.setAttribute('type', 'submit');
      addBtn.classList.remove('out-of-stock');
      addBtn.setAttribute('data-cta-mode', 'cart');
      ensureAddButtonText(addBtn, 'PRE ORDER');
    }

    if (notifyWrap) {
      notifyWrap.style.display = 'block';
      notifyWrap.removeAttribute('aria-hidden');
    }

    if (buyNow) {
      buyNow.style.display = 'none';
    }
  }

  function syncVariantURL(variantId) {
    if (!variantId) return;

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function getActiveVariantFromForm(form) {
    if (!form) return null;

    var root = getProductRoot(form);
    var variants = getVariantJsonFromRoot(root);
    var variantSelect = form.querySelector('[data-product-select]');

    if (!variantSelect || !variants.length) return null;

    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantSelect.value)) {
        return variants[i];
      }
    }

    return null;
  }

  function forceInitialVariant(form) {
    if (!form) return;

    var firstAvailableVariant = getFirstAvailableVariant(form);
    if (!firstAvailableVariant) return;

    var section = form.closest('.product-section');

    if (section && firstAvailableVariant.option1) {
      activateColorSwatch(section, firstAvailableVariant.option1);
    }

    applyVariantToUI(form, firstAvailableVariant);

    var variantSelect = form.querySelector('[data-product-select]');
    if (variantSelect) {
      variantSelect.value = String(firstAvailableVariant.id);
      variantSelect.dispatchEvent(new Event('input', { bubbles: true }));
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateCTA(form, firstAvailableVariant);
    syncVariantURL(firstAvailableVariant.id);
  }

  function bindProductForm(form) {
    if (!form || form.dataset.forceVariantBound === 'true') return;
    form.dataset.forceVariantBound = 'true';

    forceInitialVariant(form);

    setTimeout(function () {
      forceInitialVariant(form);
    }, 150);

    setTimeout(function () {
      forceInitialVariant(form);
    }, 450);

    form.addEventListener('change', function () {
      setTimeout(function () {
        var active = getActiveVariantFromForm(form);
        if (!active) return;

        updateCTA(form, active);
        syncVariantURL(active.id);
      }, 20);
    });
  }

  function repairAddToCartText(scope) {
    var buttons = (scope || document).querySelectorAll('[data-add-to-cart]');

    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.style.display === 'none') return;

      var label = btn.getAttribute('data-button-label') || 'ADD TO CART';
      ensureAddButtonText(btn, label);
    });
  }

  function getProductIdFromCard(card) {
    return card ? card.getAttribute('data-product-id') : null;
  }

  function getQuickShopModal(productId) {
    if (!productId) return null;
    return document.querySelector('#QuickShopModal-' + productId);
  }

  function getProductSection(productId) {
    if (!productId) return null;

    var directSection = document.querySelector(
      '.product-section[data-product-id="' + productId + '"]'
    );
    if (directSection) return directSection;

    var modal = getQuickShopModal(productId);
    if (!modal) return null;

    return modal.querySelector('.product-section');
  }

  function getVariantJsonFromSection(section) {
    if (!section) return [];

    var el =
      section.querySelector('.product-variants-json') ||
      section.querySelector('textarea[data-variant-json]') ||
      section.querySelector('textarea[data-current-variant-json]');

    return parseJSON(el);
  }

  function buildColorRanges(variants, slideCount) {
    var starts = {};

    variants.forEach(function (variant) {
      var color = variant.option1;
      var pos = null;

      if (variant.featured_media && variant.featured_media.position) {
        pos = Number(variant.featured_media.position);
      } else if (variant.featured_image && variant.featured_image.position) {
        pos = Number(variant.featured_image.position);
      }

      if (!color || !pos) return;

      if (!starts[color] || pos < starts[color]) {
        starts[color] = pos;
      }
    });

    var ordered = Object.keys(starts)
      .map(function (color) {
        return { color: color, start: starts[color] };
      })
      .sort(function (a, b) {
        return a.start - b.start;
      });

    var ranges = {};

    ordered.forEach(function (item, index) {
      var next = ordered[index + 1];
      ranges[item.color] = {
        start: item.start,
        end: next ? next.start - 1 : slideCount
      };
    });

    return ranges;
  }

  function getColorSlides(section, color) {
    if (!section || !color) return [];

    var variants = getVariantJsonFromSection(section);
    var slides = Array.prototype.slice.call(
      section.querySelectorAll('.product-main-slide')
    );

    if (!variants.length || !slides.length) return [];

    var ranges = buildColorRanges(variants, slides.length);
    var range = ranges[color];

    if (!range) return [];

    return slides.slice(range.start - 1, range.end);
  }

  function getColorBySlideIndex(section, slideIndex) {
    if (!section || slideIndex == null) return null;

    var variants = getVariantJsonFromSection(section);
    var slides = Array.prototype.slice.call(
      section.querySelectorAll('.product-main-slide')
    );

    if (!variants.length || !slides.length) return null;

    var ranges = buildColorRanges(variants, slides.length);
    var matchedColor = null;

    Object.keys(ranges).forEach(function (color) {
      var range = ranges[color];
      var startIndex = range.start - 1;
      var endIndex = range.end - 1;

      if (slideIndex >= startIndex && slideIndex <= endIndex) {
        matchedColor = color;
      }
    });

    return matchedColor;
  }

  function getMatchingVariantForColor(section, color) {
    if (!section || !color) return null;

    var variants = getVariantJsonFromSection(section);
    if (!variants.length) return null;

    var form = section.querySelector('.product-single__form');
    var activeVariant = getActiveVariantFromForm(form);

    var wantedOption2 = activeVariant ? activeVariant.option2 : null;
    var wantedOption3 = activeVariant ? activeVariant.option3 : null;

    var exactMatch = null;
    var availableMatch = null;
    var colorOnlyMatch = null;

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];

      if (String(variant.option1) !== String(color)) continue;

      if (!colorOnlyMatch) {
        colorOnlyMatch = variant;
      }

      if (
        String(variant.option2 || '') === String(wantedOption2 || '') &&
        String(variant.option3 || '') === String(wantedOption3 || '')
      ) {
        exactMatch = variant;
        if (variant.available) {
          return variant;
        }
      }

      if (!availableMatch && variant.available) {
        availableMatch = variant;
      }
    }

    return exactMatch || availableMatch || colorOnlyMatch || null;
  }

  function syncFormToVariant(section, variant) {
    if (!section || !variant) return;

    var form = section.querySelector('.product-single__form');
    if (!form) return;

    applyVariantToUI(form, variant);

    var variantSelect = form.querySelector('[data-product-select]');
    if (variantSelect) {
      variantSelect.value = String(variant.id);
      variantSelect.dispatchEvent(new Event('input', { bubbles: true }));
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateCTA(form, variant);
    syncVariantURL(variant.id);
  }

  function syncCardSwatches(card, color) {
    if (!card) return;

    var swatches = card.querySelectorAll('.color-option');
    Array.prototype.forEach.call(swatches, function (swatch) {
      var isMatch = swatch.getAttribute('data-color-value') === color;
      swatch.classList.toggle('is-selected', isMatch);
      swatch.classList.toggle('is-clicked', isMatch);
    });

    var openOnHover = card.querySelector('.open-on-hover');
    if (openOnHover) {
      openOnHover.setAttribute('data-selected-color', color);
    }

    card.setAttribute('data-selected-color', color);
  }

  function isHomepageCard(card) {
    return !!card.closest('.shop-the-look-featured');
  }

  function updateCardImages(card, color) {
    if (!card || !color) return;

    var productId = getProductIdFromCard(card);
    if (!productId) return;

    var section = getProductSection(productId);
    if (!section) return;

    var colorSlides = getColorSlides(section, color);
    if (!colorSlides.length) return;

    var primaryImg = card.querySelector('.grid-product__image');
    var hoverImg = card.querySelector('.mouseover-image');

    if (!primaryImg) return;

    var firstSlide = colorSlides[0];
    var fourthSlide = colorSlides[Math.min(3, colorSlides.length - 1)] || colorSlides[0];

    var firstImage = getImageDataFromSlide(firstSlide);
    var fourthImage = getImageDataFromSlide(fourthSlide);

    if (!firstImage || !firstImage.src) return;

    setImage(primaryImg, firstImage);

    if (hoverImg) {
      setImage(hoverImg, fourthImage && fourthImage.src ? fourthImage : firstImage);
    }

    card.setAttribute('data-default-src', firstImage.src || '');
    card.setAttribute('data-default-srcset', firstImage.srcset || '');
    card.setAttribute(
      'data-hover-src',
      fourthImage && fourthImage.src ? fourthImage.src : firstImage.src || ''
    );
    card.setAttribute(
      'data-hover-srcset',
      fourthImage && fourthImage.srcset ? fourthImage.srcset : firstImage.srcset || ''
    );
  }

  function bindHomepageCard(card) {
    if (!card || card.dataset.homepageBound === 'true') return;

    card.dataset.homepageBound = 'true';

    card.addEventListener('mouseenter', function () {
      var hoverSrc = card.getAttribute('data-hover-src');
      var hoverSrcset = card.getAttribute('data-hover-srcset') || '';
      var primaryImg = card.querySelector('.grid-product__image');

      if (!primaryImg || !hoverSrc) return;

      setImage(primaryImg, {
        src: hoverSrc,
        srcset: hoverSrcset
      });
    });

    card.addEventListener('mouseleave', function () {
      var defaultSrc = card.getAttribute('data-default-src');
      var defaultSrcset = card.getAttribute('data-default-srcset') || '';
      var primaryImg = card.querySelector('.grid-product__image');

      if (!primaryImg || !defaultSrc) return;

      setImage(primaryImg, {
        src: defaultSrc,
        srcset: defaultSrcset
      });
    });
  }

  function resetSlidesAndThumbs(section) {
    var slides = section.querySelectorAll('.product-main-slide');
    var thumbs = section.querySelectorAll('.product__thumb-item');

    Array.prototype.forEach.call(slides, function (slide) {
      slide.classList.remove('is-selected', 'starting-slide');
      slide.setAttribute('aria-hidden', 'true');
      slide.setAttribute('tabindex', '-1');
    });

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.classList.remove('is-active');
      var link = thumb.querySelector('.product__thumb');
      if (link) link.classList.remove('is-active');
    });
  }

  function syncSelectedColorIndicator(section, color) {
    if (!section || !color) return;

    var colorWrap = section.querySelector('.variant-input-wrap--color');
    if (!colorWrap) return;

    var items = colorWrap.querySelectorAll('.variant-input');

    Array.prototype.forEach.call(items, function (item) {
      var input = item.querySelector('input[type="radio"], [data-variant-input]');
      var value =
        (input && (input.value || input.getAttribute('value'))) ||
        item.getAttribute('data-value') ||
        '';

      var itemIndex =
        (input && input.getAttribute('data-index')) ||
        item.getAttribute('data-index') ||
        '';

      var ignoreDisabled = shouldIgnoreDisabledState(itemIndex, item, input);

      var isDisabled =
        !ignoreDisabled &&
        (
          item.classList.contains('is-disabled') ||
          item.getAttribute('aria-disabled') === 'true' ||
          item.getAttribute('data-size-stock') === '0' ||
          (input && (
            input.disabled ||
            input.classList.contains('is-disabled') ||
            input.getAttribute('aria-disabled') === 'true' ||
            input.getAttribute('data-size-stock') === '0'
          ))
        );

      var isMatch = !isDisabled && String(value) === String(color);

      item.classList.toggle('is-selected', isMatch);
      item.classList.toggle('is-clicked', isMatch);
      item.setAttribute('aria-checked', isMatch ? 'true' : 'false');

      var label = item.querySelector('label');
      if (label) {
        label.classList.toggle('is-selected', isMatch);
        label.classList.toggle('is-clicked', isMatch);
      }

      if (input && 'checked' in input) {
        input.checked = isMatch;
      }
    });

    colorWrap.setAttribute('data-selected-color', color);

    var colorLabel = section.querySelector('[data-variant-color-label]');
    if (colorLabel) {
      colorLabel.textContent = color;
    }
  }

  function activateColorSwatch(section, color, preferredIndex) {
    if (!section || !color) return false;

    if (preferredIndex != null) {
      section._preferredColorSlideIndex = preferredIndex;
    }

    var wrap = section.querySelector('.variant-input-wrap--color');
    var escapedColor = color.replace(/"/g, '\\"');

    function syncSwatchClasses() {
      if (!wrap) return;

      var items = wrap.querySelectorAll('.variant-input');

      Array.prototype.forEach.call(items, function (item) {
        var input = item.querySelector('input[type="radio"], [data-variant-input]');
        var value =
          (input && (input.value || input.getAttribute('value'))) ||
          item.getAttribute('data-value') ||
          '';

        var itemIndex =
          (input && input.getAttribute('data-index')) ||
          item.getAttribute('data-index') ||
          '';

        var ignoreDisabled = shouldIgnoreDisabledState(itemIndex, item, input);

        var isDisabled =
          !ignoreDisabled &&
          (
            item.classList.contains('is-disabled') ||
            item.getAttribute('aria-disabled') === 'true' ||
            item.getAttribute('data-size-stock') === '0' ||
            (input && (
              input.disabled ||
              input.classList.contains('is-disabled') ||
              input.getAttribute('aria-disabled') === 'true' ||
              input.getAttribute('data-size-stock') === '0'
            ))
          );

        var isMatch = !isDisabled && String(value) === String(color);

        item.classList.toggle('is-selected', isMatch);
        item.classList.toggle('is-clicked', isMatch);

        if (input && 'checked' in input) {
          input.checked = isMatch;
        }
      });
    }

    var input = section.querySelector(
      '.variant-input-wrap--color input[type="radio"][value="' + escapedColor + '"]'
    );

    var item = input ? input.closest('.variant-input') : null;
    var clickable =
      (item && item.querySelector('label, button')) ||
      item ||
      input;

    syncSwatchClasses();
    syncSelectedColorIndicator(section, color);

    if (clickable && typeof clickable.click === 'function') {
      clickable.click();
    }

    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var matchedVariant = getMatchingVariantForColor(section, color);
    if (matchedVariant) {
      syncFormToVariant(section, matchedVariant);
    } else {
      applyGalleryColor(section, color);
    }

    return !!input || !!item;
  }

  function bindColorBoundarySwitch(section) {
    if (!section || section.dataset.colorBoundaryBound === 'true') return;
    section.dataset.colorBoundaryBound = 'true';

    var flickityEl = section.querySelector('.product-slideshow');
    if (!flickityEl || !window.Flickity) return;

    var flkty = window.Flickity.data(flickityEl);
    if (!flkty) return;

    flkty.on('change', function (index) {
      if (section._isBoundarySwitching) return;

      var currentColor = getCurrentColor(section);
      var targetColor = getColorBySlideIndex(section, index);

      if (!currentColor || !targetColor || currentColor === targetColor) return;

      section._isBoundarySwitching = true;
      activateColorSwatch(section, targetColor, index);

      setTimeout(function () {
        section._isBoundarySwitching = false;
      }, 120);
    });
  }

  function applyGalleryColor(section, color) {
    if (!section || !color) return;

    var slides = Array.prototype.slice.call(
      section.querySelectorAll('.product-main-slide')
    );
    var thumbs = Array.prototype.slice.call(
      section.querySelectorAll('.product__thumb-item')
    );
    var variants = getVariantJsonFromSection(section);

    if (!slides.length || !variants.length) return;

    var ranges = buildColorRanges(variants, slides.length);
    var range = ranges[color];
    if (!range) return;

    var startIndex = range.start - 1;
    var endIndex = range.end - 1;
    var preferredIndex = section._preferredColorSlideIndex;
    var targetIndex =
      preferredIndex != null && preferredIndex >= startIndex && preferredIndex <= endIndex
        ? preferredIndex
        : startIndex;

    delete section._preferredColorSlideIndex;

    slides.forEach(function (slide, index) {
      var visible = index >= startIndex && index <= endIndex;
      slide.classList.toggle('is-color-hidden', !visible);
      slide.style.display = visible ? '' : 'none';
    });

    thumbs.forEach(function (thumb, index) {
      var visible = index >= startIndex && index <= endIndex;
      thumb.classList.toggle('is-color-hidden', !visible);
      thumb.style.display = visible ? '' : 'none';
    });

    resetSlidesAndThumbs(section);

    var activeSlide = slides[targetIndex];
    if (activeSlide) {
      activeSlide.classList.add('is-selected', 'starting-slide');
      activeSlide.setAttribute('aria-hidden', 'false');
      activeSlide.setAttribute('tabindex', '0');
    }

    var activeThumb = thumbs[targetIndex];
    if (activeThumb) {
      activeThumb.classList.add('is-active');
      var activeThumbLink = activeThumb.querySelector('.product__thumb');
      if (activeThumbLink) activeThumbLink.classList.add('is-active');
    }

    var flickityEl = section.querySelector('.product-slideshow');

    if (flickityEl && window.Flickity && window.Flickity.data(flickityEl)) {
      var flkty = window.Flickity.data(flickityEl);

      flkty.reloadCells();
      flkty.resize();

      setTimeout(function () {
        flkty.reloadCells();
        flkty.resize();
        flkty.select(targetIndex, false, true);
      }, 40);
    }
  }

  function getCurrentColor(section) {
    if (!section) return null;

    var checked = section.querySelector(
      '.variant-input-wrap--color input[type="radio"]:checked'
    );
    if (checked) return checked.value;

    var selected = section.querySelector(
      '.variant-input-wrap--color .variant-input.is-selected'
    );
    if (selected) return selected.getAttribute('data-value');

    var label = section.querySelector('[data-variant-color-label]');
    if (label && label.textContent.trim()) return label.textContent.trim();

    return null;
  }

  function initCards() {
    var cards = document.querySelectorAll('.grid-product[data-product-id]');

    Array.prototype.forEach.call(cards, function (card) {
      bindHomepageCard(card);

      var selected =
        card.querySelector('.color-option.is-selected') ||
        card.querySelector('.open-on-hover[data-selected-color]');

      var color = selected
        ? selected.getAttribute('data-color-value') ||
          selected.getAttribute('data-selected-color')
        : card.getAttribute('data-selected-color');

      if (!color) return;

      syncCardSwatches(card, color);
      updateCardImages(card, color);
    });
  }

  function initProductSections() {
    var sections = document.querySelectorAll('.product-section');

    Array.prototype.forEach.call(sections, function (section) {
      var hasColor = section.querySelector('.variant-input-wrap--color');
      if (!hasColor) return;

      bindColorBoundarySwitch(section);

      var color = getCurrentColor(section);
      if (!color) return;

      syncSelectedColorIndicator(section, color);
      applyGalleryColor(section, color);
    });
  }

  function initMobileLeftPeekGallery() {
    if (!window.Flickity) return;
    if (window.innerWidth > 768) return;

    var sections = document.querySelectorAll('.product-section');

    Array.prototype.forEach.call(sections, function (section) {
      var flickityEl = section.querySelector('.product-slideshow');
      if (!flickityEl) return;

      var flkty = window.Flickity.data(flickityEl);
      if (!flkty) return;

      flickityEl.classList.add('is-mobile-left-peek');

      flkty.options.cellAlign = 'left';
      flkty.options.contain = false;

      flkty.reloadCells();
      flkty.resize();
      flkty.reposition();

      setTimeout(function () {
        flkty.reloadCells();
        flkty.resize();
        flkty.reposition();
        flkty.select(flkty.selectedIndex || 0, false, true);
      }, 60);
    });
  }

  function initLanguageSwitcher() {
    var languageItems = document.querySelectorAll('#LangList-toolbar > li');

    if (!languageItems.length) return;

    Array.prototype.forEach.call(languageItems, function (el) {
      var link = el.querySelector('a');
      var span = el.querySelector('a > span');

      if (!link || !span) return;

      var getLang = link.getAttribute('lang');
      if (getLang) {
        span.textContent = getLang;
      }
    });
  }

  function initHeaderSlideSubmenu() {
    var menus = document.querySelectorAll('.site-nav__details');

    for (var i = 0; i < menus.length; i++) {
      (function (menu) {
        var dropdown = menu.querySelector('.site-nav__dropdown');
        if (!dropdown) return;

        menu.addEventListener('toggle', function () {
          if (menu.open) {
            animateSlide(dropdown, -100, 0, 100);
          } else {
            animateSlide(dropdown, 0, -100, 100);
          }
        });
      })(menus[i]);
    }
  }

  function initCloseItems() {
    var closeItems = document.querySelectorAll('.close-item');

    Array.prototype.forEach.call(closeItems, function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();

        var details = e.target.closest('.site-nav__details');
        if (details) {
          details.removeAttribute('open');
        }
      });
    });
  }

  function getFieldErrorElement(container) {
    if (!container) return null;
    return container.querySelector('.field-error-message');
  }

  function ensureFieldErrorElement(container) {
    if (!container) return null;

    var errorEl = getFieldErrorElement(container);

    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.className = 'field-error-message';
      container.appendChild(errorEl);
    }

    return errorEl;
  }

  function setFieldError(field, message) {
    if (!field || !field.parentNode) return;

    var container = field.parentNode;
    var errorEl = ensureFieldErrorElement(container);
    if (!errorEl) return;

    if (message) {
      field.classList.add('input-error');
      errorEl.textContent = message;
      errorEl.style.display = 'block';
    } else {
      field.classList.remove('input-error');
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function clearFieldError(field) {
    if (!field || !field.parentNode) return;

    field.classList.remove('input-error');

    var errorEl = getFieldErrorElement(field.parentNode);
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function setGroupError(container, message) {
    if (!container) return;

    var errorEl = ensureFieldErrorElement(container);
    if (!errorEl) return;

    if (message) {
      container.classList.add('input-error');
      errorEl.textContent = message;
      errorEl.style.display = 'block';
    } else {
      container.classList.remove('input-error');
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function getInputErrorMessage(input) {
    if (!input) return '';

    if (input.validity && input.validity.valueMissing) {
      return 'This field is required.';
    }

    if (input.type === 'email' && input.validity && input.validity.typeMismatch) {
      return 'Please enter a valid email address.';
    }

    if (typeof input.checkValidity === 'function' && !input.checkValidity()) {
      return 'Please check this field.';
    }

    return '';
  }

  function initNewsletterValidation() {
    var form = document.getElementById('newsletter-footer');
    if (!form || form.dataset.validationBound === 'true') return;

    form.dataset.validationBound = 'true';
    form.setAttribute('novalidate', 'novalidate');

    var email = form.querySelector('input[type="email"]');
    var checkbox = document.getElementById('privacy-newsletter');
    var submitBtn = document.getElementById('newsletter-submit-newsletter');

    if (!email || !checkbox) return;

    var checkboxWrap =
      checkbox.closest(
        '.footer__newsletter-checkbox, .newsletter-privacy, .privacy-wrap, .form__checkbox, .checkbox-wrap'
      ) || checkbox.parentNode;

    var hasSubmitted = false;
    var emailTouched = false;

    function validateForm(showErrors) {
      var emailValue = email.value.trim();
      var emailValid = emailValue !== '' && email.checkValidity();
      var checkboxValid = checkbox.checked;
      var isValid = emailValid && checkboxValid;

      clearFieldError(email);
      setGroupError(checkboxWrap, '');

      if (showErrors) {
        if (emailTouched || hasSubmitted) {
          email.classList.toggle('input-error', !emailValid);
        }

        if (!checkboxValid) {
          setGroupError(checkboxWrap, 'You must accept the privacy policy.');
        }
      } else {
        email.classList.remove('input-error');
      }

      if (submitBtn) {
        submitBtn.disabled = !isValid;
      }

      return isValid;
    }

    email.addEventListener('input', function () {
      validateForm(hasSubmitted);
    });

    email.addEventListener('blur', function () {
      emailTouched = true;
      validateForm(true);
    });

    checkbox.addEventListener('change', function () {
      validateForm(true);
    });

    form.addEventListener('submit', function (e) {
      hasSubmitted = true;
      emailTouched = true;

      var isValid = validateForm(true);

      if (!isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);

    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        hasSubmitted = true;
        emailTouched = true;

        var isValid = validateForm(true);

        if (!isValid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
      }, true);
    }

    validateForm(false);
  }

  function initContactValidation() {
    var form =
      document.getElementById('contact-template--28275972505945__form') ||
      document.querySelector('form[id*="contact-template--"]');

    if (!form || form.dataset.validationBound === 'true') return;

    form.dataset.validationBound = 'true';
    form.setAttribute('novalidate', 'novalidate');

    var inputs = form.querySelectorAll('input[required], textarea[required]');
    var checkbox = form.querySelector('.contact-privacy input[type="checkbox"]');
    var privacyWrap = form.querySelector('.contact-privacy');

    var hasSubmitted = false;

    Array.prototype.forEach.call(inputs, function (input) {
      input._touched = false;
    });

    function validateForm(showErrors) {
      var allValid = true;

      Array.prototype.forEach.call(inputs, function (input) {
        if (input.type === 'checkbox') return;

        var message = getInputErrorMessage(input);
        var isValid = !message;

        if (!isValid) {
          allValid = false;
        }

        if (showErrors && (input._touched || hasSubmitted)) {
          setFieldError(input, message);
        } else {
          clearFieldError(input);
        }
      });

      if (checkbox) {
        var checkboxValid = checkbox.checked;

        if (!checkboxValid) {
          allValid = false;
        }

        if (hasSubmitted) {
          setGroupError(
            privacyWrap,
            checkboxValid ? '' : 'You must accept the privacy policy.'
          );
        } else {
          setGroupError(privacyWrap, '');
        }
      }

      return allValid;
    }

    Array.prototype.forEach.call(inputs, function (input) {
      if (input.type === 'checkbox') return;

      input.addEventListener('blur', function () {
        input._touched = true;
        validateForm(true);
      });
    });

    if (checkbox) {
      checkbox.addEventListener('change', function () {
        if (hasSubmitted) {
          validateForm(true);
        }
      });
    }

    form.addEventListener('submit', function (e) {
      hasSubmitted = true;

      Array.prototype.forEach.call(inputs, function (input) {
        input._touched = true;
      });

      if (!validateForm(true)) {
        e.preventDefault();
      }
    });

    validateForm(false);
  }

  function initProductForms() {
    var forms = document.querySelectorAll('.product-single__form');
    Array.prototype.forEach.call(forms, bindProductForm);
  }

  function rebindProductForms() {
    var forms = document.querySelectorAll('.product-single__form');

    Array.prototype.forEach.call(forms, function (form) {
      delete form.dataset.forceVariantBound;
    });

    initProductForms();
    repairAddToCartText(document);
    initCards();
    initProductSections();
    initMobileLeftPeekGallery();
  }

  function bindGlobalEvents() {
    document.addEventListener('click', function (e) {
      var swatch = e.target.closest('.color-option');
      if (swatch) {
        var card = swatch.closest('.grid-product[data-product-id]');
        if (!card) return;

        var color = swatch.getAttribute('data-color-value');
        if (!color) return;

        syncCardSwatches(card, color);
        updateCardImages(card, color, isHomepageCard(card));

        var productId = getProductIdFromCard(card);
        var section = getProductSection(productId);

        if (section) {
          activateColorSwatch(section, color);
        }

        return;
      }

      var trigger = e.target.closest(QUICKSHOP_TRIGGER_SELECTOR);
      if (trigger) {
        setTimeout(rebindProductForms, 250);
        setTimeout(rebindProductForms, 600);
      }
    });

    document.addEventListener('change', function (e) {
      if (
        e.target.matches('[data-variant-input]') ||
        e.target.matches('[data-product-select]')
      ) {
        setTimeout(function () {
          repairAddToCartText(document);
        }, 50);
      }

      if (e.target.matches('.variant__input--color-swatch')) {
        var input = e.target;
        var section = input.closest('.product-section');
        if (!section) return;

        var color = input.value;
        syncSelectedColorIndicator(section, color);

        var matchedVariant = getMatchingVariantForColor(section, color);

        if (matchedVariant) {
          syncFormToVariant(section, matchedVariant);
        }

        applyGalleryColor(section, color);

        var productId = section.getAttribute('data-product-id');
        if (!productId) return;

        var cards = document.querySelectorAll(
          '.grid-product[data-product-id="' + productId + '"]'
        );

        Array.prototype.forEach.call(cards, function (card) {
          syncCardSwatches(card, color);
          updateCardImages(card, color, false);
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLanguageSwitcher();
    initHeaderSlideSubmenu();
    initCloseItems();
    initNewsletterValidation();
    initContactValidation();
    initProductForms();
    repairAddToCartText(document);
    initCards();
    initProductSections();
    initMobileLeftPeekGallery();
    bindGlobalEvents();
  });
})();